/**
 * Import Lib & assets
 */

import React from "react";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

/**
 * star component is..
 */

const Svg__star = ({ filled, style, half }) => {
  const color = filled ? t.color.secondary : t.color.grey;
  if (half) {
    return (
      <svg width="15" height="15" viewBox="0 0 28 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Forme-3">
                <path d="M27.481,9.88 C27.3932175,9.61220916 27.1602304,9.41805324 26.881,9.38 L18.275,8.14 L14.427,0.41 C14.2995032,0.158808882 14.0416956,0.000548371728 13.76,0.000548371728 C13.4783044,0.000548371728 13.2204968,0.158808882 13.093,0.41 L9.244,8.14 L0.638,9.38 C0.358567893,9.41759512 0.125368204,9.61192819 0.038,9.88 C-0.0510484226,10.1452669 0.0223554477,10.4381015 0.226,10.63 L6.453,16.65 L4.983,25.14 C4.9360587,25.4181508 5.05200133,25.6986955 5.28161433,25.8625528 C5.51122733,26.0264101 5.81422675,26.0448323 6.062,25.91 L13.762,21.91 L21.462,25.91 C21.5678838,25.968734 21.6869175,25.9996965 21.808,26 C21.9648011,25.9987184 22.1175252,25.9499025 22.246,25.86 C22.4734976,25.6955571 22.5894264,25.417328 22.546,25.14 L21.076,16.65 L27.303,10.63 C27.502654,10.4356144 27.5720132,10.1433707 27.481,9.88 L27.481,9.88 Z" id="Forme_3" fill="#CACACA"></path>
                <path d="M0.240775888,0.000548371728 C0.522471475,0.000548371728 0.780279121,0.158808882 0.907775888,0.41 L0.907775888,0.41 L4.75577589,8.14 L13.3617759,9.38 C13.6410063,9.41805324 13.8739934,9.61220916 13.9617759,9.88 C14.0527891,10.1433707 13.9834299,10.4356144 13.7837759,10.63 L13.7837759,10.63 L7.55677589,16.65 L9.02677589,25.14 C9.07020231,25.417328 8.95427352,25.6955571 8.72677589,25.86 C8.59830106,25.9499025 8.44557703,25.9987184 8.28877589,26 C8.16769335,25.9996965 8.04865973,25.968734 7.94277589,25.91 L7.94277589,25.91 L0.242775888,21.91 L0.000999999999,22.0345484 L0.000647932148,0.0401198619 C0.044502727,0.0252483329 0.0899494428,0.0143816316 0.136467648,0.00783923569 Z" id="Combined-Shape" fill="#FFDC28" transform="translate(7.000615, 13.000274) scale(-1, 1) translate(-7.000615, -13.000274) "></path>
            </g>
        </g>
    </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" style={style}>
      <path
        fillRule="evenodd"
        fill={color}
        d="M14.686 5.616a.39.39 0 00-.316-.265l-4.54-.653L7.799.621a.394.394 0 00-.704 0L5.064 4.698l-4.54.653a.391.391 0 00-.317.265.381.381 0 00.099.398l3.286 3.173-.777 4.48a.39.39 0 00.156.38.397.397 0 00.414.03l4.062-2.115 4.061 2.115a.392.392 0 00.412-.03.384.384 0 00.157-.38l-.775-4.48 3.286-3.173a.385.385 0 00.098-.398z"
      />
    </svg>
  );
};

export default Svg__star;

Svg__star.propTypes = {
  filled: PropTypes.bool,
};

Svg__star.defaultProps = {
  filled: false,
};
